import { GovInfobar, type GovInfobarProps } from '@gov-design-system-ce/react';

export const Infobar = (props: GovInfobarProps) => <GovInfobar {...props} />;
